export const thousandFormat = (value) => (
  value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
)

export default null
